import { differenceInDays, format, getWeek, isValid, parseISO } from "date-fns";
export const filterDriversByDateRange = (drivers, fromDate, toDate) => {
    const selectedStart = new Date(fromDate);
    const selectedEnd = new Date(toDate);
    if (isValid(selectedStart) === false || isValid(selectedEnd) === false) {
        console.warn("Invalid date strings provided to filterDriversByDateRange", {
            fromDate,
            toDate,
        });
        return [];
    }
    return drivers.filter((driver) => {
        const periodStart = new Date(driver.period.minDate);
        const periodEnd = new Date(driver.period.maxDate);
        if (isValid(periodStart) === false || isValid(periodEnd) === false) {
            console.warn("Invalid driver period dates", driver.period);
            return false;
        }
        return periodStart >= selectedStart && periodEnd <= selectedEnd;
    });
};
const formatPeriodDisplay = (startDate, endDate) => {
    const daysDiff = differenceInDays(endDate, startDate);
    const startWeek = getWeek(startDate);
    const endWeek = getWeek(endDate);
    const dateFormat = "d MMM yyyy";
    if (daysDiff === 0) {
        return `${format(startDate, dateFormat)} ( WK${startWeek} )`;
    }
    const weekPrefix = startWeek === endWeek ? `WK${startWeek}` : `WK${startWeek} - WK${endWeek}`;
    return `${format(startDate, dateFormat)} - ${format(endDate, dateFormat)} ( ${weekPrefix} )`;
};
export const transformDriverToTableRow = (driver) => {
    const { period, originalForecast, draftForecast, adjustedForecast, adjustmentPercentage, } = driver;
    const startDate = parseISO(period.minDate);
    const endDate = parseISO(period.maxDate);
    const periodDisplay = formatPeriodDisplay(startDate, endDate);
    const newForecast = draftForecast ?? adjustedForecast ?? originalForecast;
    const delta = newForecast - originalForecast;
    const sign = delta >= 0 ? "+" : "";
    const oldFormatted = Math.round(originalForecast).toLocaleString();
    const newFormatted = Math.round(newForecast).toLocaleString();
    const deltaFormatted = Math.round(delta).toLocaleString();
    const forecastDisplay = `${oldFormatted} → ${newFormatted} (${sign}${deltaFormatted})`;
    return {
        driverId: driver.driverId,
        driver: driver.driverName,
        period: periodDisplay,
        forecast: forecastDisplay,
        adjustmentPercentage,
    };
};
const QUERY_KEY_START_DATE_INDEX = 3;
const QUERY_KEY_END_DATE_INDEX = 4;
const QUERY_KEY_EXPECTED_LENGTH = 6;
export const hasMatchingDateRange = (queryKey, fromDate, toDate) => {
    if (queryKey.length < QUERY_KEY_EXPECTED_LENGTH)
        return false;
    const startDate = queryKey[QUERY_KEY_START_DATE_INDEX];
    const endDate = queryKey[QUERY_KEY_END_DATE_INDEX];
    return startDate === fromDate && endDate === toDate;
};
//# sourceMappingURL=publishUtils.js.map